import { modals } from '@mantine/modals';

import { useUpdateShopCommissionMutation } from '../store/shop-commissions-api';
import { useShowResponseStatus } from '@/shared';

import type { TShopCommissionUpdateParams, TShopCommission } from '../store/types';

export const useUpdateShopCommission = () => {
  const [updateShopCommission, { isLoading, isSuccess, isError }] = useUpdateShopCommissionMutation();

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Комиссия успешно обновлена',
    isError,
    errorMassage: 'При обновлении комиссии произошла ошибка',
  });

  const handleShopCommissionUpdate = async (params: TShopCommissionUpdateParams) => {
    await updateShopCommission(params);
  };

  const openEditModal = (params: TShopCommission, elem: React.ReactNode) => modals.open({
    title: `Редактирование комиссии для "${params.shopName}"`,
    centered: true,
    children: elem,
  });

  return {
    updateShopCommission,
    handleShopCommissionUpdate,
    openEditModal,
    isLoading,
  };
};
